import { FC } from 'react';
import { Datagrid, DeleteButton, List, ListProps, ReferenceField, TextField, useRecordContext } from 'react-admin';
import { Close } from '@mui/icons-material';
import RelativeTimeField from '../units/RelativeTimeField';

const ActionsField = () => {
  const record = useRecordContext();
  return <>{!record?.deleted_at && <DeleteButton label="close" startIcon={<Close />} mutationMode="pessimistic" />}</>;
};
const VPNList: FC<ListProps> = () => (
  <List perPage={25}>
    <Datagrid rowClick="show" bulkActionButtons={false}>
      <TextField source="id" />
      <TextField source="status" sortable={false} />
      <TextField source="ip_address" sortable={false} />
      <ReferenceField source="unit_id" reference="units">
        <TextField source="serial" />
      </ReferenceField>
      <RelativeTimeField source="created_at" />
      <RelativeTimeField source="deleted_at" />
      <ActionsField />
    </Datagrid>
  </List>
);

export default VPNList;
